import { render, staticRenderFns } from "./AgeInput.vue?vue&type=template&id=02c2e19e"
import script from "./AgeInput.vue?vue&type=script&lang=ts"
export * from "./AgeInput.vue?vue&type=script&lang=ts"
import style0 from "./AgeInput.vue?vue&type=style&index=0&id=02c2e19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports